module.exports = __webpack_public_path__ + "img/ADFS-logo.4e39d6cc.png";